import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { FixedJobFormDialog } from './FixedJobFormDialog';

interface Props {
  teacherCode?: string;
  weekday: number;
}

export function FixedJobsList({ weekday }: Props) {
  const qc = useQueryClient();
  const [editing, setEditing] = React.useState<any | null>(null);

  const jobsQuery = useQuery({
    queryKey: ['admin-fixed-jobs', weekday],
    enabled: true,
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('fixed_jobs_with_students')
        .select('id, subject, location, weekday, start_time, end_time, is_active, students')
        .eq('weekday', weekday)
        .order('start_time');
      if (error) throw error;
      return data ?? [];
    }
  });

  const toggleActive = useMutation({
    mutationFn: async (p: { id: string; is_active: boolean }) => {
      const { error } = await (supabase as any)
        .from('fixed_jobs')
        .update({ is_active: p.is_active })
        .eq('id', p.id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin-fixed-jobs'] })
  });

  return (
    <div className="space-y-3">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>เวลา</TableHead>
            <TableHead>วิชา</TableHead>
            <TableHead>สถานที่</TableHead>
            <TableHead>จำนวนนักเรียน</TableHead>
            <TableHead>เปิดใช้งาน</TableHead>
            <TableHead className="text-right">จัดการ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {(jobsQuery.data ?? []).map((j: any) => (
            <TableRow key={j.id}>
              <TableCell>{j.start_time}–{j.end_time}</TableCell>
              <TableCell>{j.subject}</TableCell>
              <TableCell>{j.location}</TableCell>
              <TableCell>{Array.isArray(j.students) ? j.students.length : 0}</TableCell>
              <TableCell>
                <Switch checked={!!j.is_active} onCheckedChange={(v) => toggleActive.mutate({ id: j.id, is_active: v })} />
              </TableCell>
              <TableCell className="text-right">
                <Button size="sm" variant="secondary" onClick={() => setEditing(j)}>แก้ไข</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <FixedJobFormDialog
        open={!!editing}
        onOpenChange={(o) => !o && setEditing(null)}
        teacherCode={editing?.teacher_code}
        initial={editing || undefined}
      />
    </div>
  );
}


